import { BrandPortalIssuesPrototypeRoutes } from "@faire/prototype-playground/workspace/ck/brand-portal-issues-page/BrandPortalIssuesPrototypeRoutes";
import NetTermsUpsellAtCheckoutPage from "@faire/prototype-playground/workspace/ck/net-terms-upsell";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const DeactivateFairePayPage = lazy(
  () => import("../../pages/DeactivateFairePayPage")
);

import OpeningSoonConfirmationModalPage from "@faire/prototype-playground/workspace/ck/opening-soon-confirmation-modal";

const EarlyPayPage = withCompass(() => import("../../pages/EarlyPayPage"));
const FaireCheckoutReplicaPage = lazy(
  () => import("../../pages/FaireCheckoutReplicaPage")
);
const FairePayEmailPage = lazy(() => import("../../pages/FairePayEmailPage"));
const FairePayPaymentModalPage = withCompass(
  () => import("../../pages/FairePayPaymentModalPage")
);
const FairePaySprintPage = withCompass(
  () => import("../../pages/FairePaySprintPage")
);
const FairePayTestPage = lazy(() => import("../../pages/FairePayTestPage"));
const FairePayTouchpointsPage = withCompass(
  () => import("../../pages/FairePayTouchpointsPage")
);
const MultistepKYBPage = withCompass(
  () => import("../../pages/MultistepKYBPage")
);

export function CarolynKaoRoutes() {
  return (
    <Switch>
      <Route
        path="/ck/brand-portal-issues-page"
        component={BrandPortalIssuesPrototypeRoutes}
      />
      <Route
        path="/ck/deactivate-faire-pay"
        component={DeactivateFairePayPage}
      />
      <Route path="/ck/early-pay" component={EarlyPayPage} />
      <Route
        path="/ck/faire-checkout-replica"
        component={FaireCheckoutReplicaPage}
      />
      <Route path="/ck/faire-pay-email" component={FairePayEmailPage} />
      <Route path="/ck/faire-pay-sprint" component={FairePaySprintPage} />
      <Route
        path="/ck/faire-pay-payment-modal"
        component={FairePayPaymentModalPage}
      />
      <Route path="/ck/faire-pay-test" component={FairePayTestPage} />
      <Route
        path="/ck/faire-pay-touchpoints"
        component={FairePayTouchpointsPage}
      />
      <Route path="/ck/multistep-kyb" component={MultistepKYBPage} />
      <Route path="/ck/net-terms-upsell" component={NetTermsUpsellAtCheckoutPage} />
      <Route path="/ck/opening-soon-confirmation-modal" component={OpeningSoonConfirmationModalPage} />
    </Switch>
  );
}

export const slug = "ck";
